import { render, staticRenderFns } from "./ImageDetailsStepFive.vue?vue&type=template&id=54aef410&scoped=true&"
import script from "./ImageDetailsStepFive.vue?vue&type=script&lang=js&"
export * from "./ImageDetailsStepFive.vue?vue&type=script&lang=js&"
import style0 from "./ImageDetailsStepFive.vue?vue&type=style&index=0&id=54aef410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aef410",
  null
  
)

export default component.exports